import { Component, AfterViewInit, OnInit, ChangeDetectorRef } from '@angular/core';
import { MyserviceService } from '../../provider/myservice.service';
import Swal from 'sweetalert2';
import { ActivatedRoute, Router } from '@angular/router';
import { user_position_lang } from "../../language/user_position";
import * as L from 'leaflet';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { enGbLocale } from 'ngx-bootstrap/locale';
import { thLocale } from 'ngx-bootstrap/locale';
defineLocale('engb', enGbLocale);
defineLocale('th', thLocale);
declare var url;

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

class user {
  user_id: string;
  user_name: string;
  phoneno: string;
  status: string;
  lastlogin: any
}

@Component({
  selector: 'app-user-position',
  templateUrl: './user-position.component.html',
  styleUrls: ['./user-position.component.scss']
})

export class UserPositionComponent implements AfterViewInit {
  zone_name: any = "";
  mapbox: any = null;
  map;
  lat = 19.14008388;
  lon = 99.91081981;
  marker = "";
  polygon;
  isLoading = true;
  showPage = false;
  lang = localStorage.getItem('lang') == "EN" ? "EN" : "TH";
  language: any;
  search_user = "";
  municipality_id = "";
  token = '';
  database = '';
  dtOptions: DataTables.Settings = {};
  users: user[];
  constructor(
    private http: HttpClient,
    private service: MyserviceService,
    private chRef: ChangeDetectorRef,
    private route: ActivatedRoute,
    private localeService: BsLocaleService,
    private router: Router,
    private modalService: BsModalService) {
    this.language = user_position_lang[this.lang];

  }

  ngOnInit() {

    this.municipality_id = JSON.parse(sessionStorage.getItem('municipality')).municipality_id;
    if (sessionStorage.getItem('municipality') != undefined) {
      this.database = JSON.parse(sessionStorage.getItem('municipality')).municipality_id + '_fee'
    }

    if (sessionStorage.getItem('token') != undefined) {
      this.token = sessionStorage.getItem('token');
    }

    this.isLoading = false;
    this.showPage = true;
    const that = this;
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      serverSide: true,
      processing: true,
      ajax: (dataTablesParameters: any, callback) => {
        console.log('user-location/get-user_to_datatable')
        that.http
          .post<DataTablesResponse>(
            url + 'user-location/get-user_to_datatable',
            dataTablesParameters, {
            headers: new HttpHeaders({
              'Content-Type': 'application/json; charset=utf-8',
              'x-access-token': this.token,
              'database': this.database,
              'municipality_id': this.municipality_id
            })
          }
          ).subscribe(resp => {
            //debugger 
            that.users = resp.data.map((item) => {
              return item;
            });
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: []
            });
          });
      },
      columns: [{ data: 'user_id' }, { data: 'user_name' }, { data: `(case when mobile_status = '1' then 'Online' else 'Offline' end)` },  {data:''}]
    };

    this.route.queryParams.subscribe(params => {
      this.lang = params['lang'];
      if (this.lang != 'EN' && this.lang != 'TH') {
        this.lang = localStorage.getItem('lang') == 'EN' ? 'EN' : 'TH';
        this.language = user_position_lang[this.lang];
      } else {
        this.language = user_position_lang[this.lang];
        localStorage.setItem('lang', this.lang);
      }
    });
  }

  ngAfterViewInit(): void {
    this.initMap();
  }

  private initMap(): void {
    var streets_satellite = L.tileLayer(
      "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
      {
        attribution: "Mapbox",
        tileSize: 512,
        zoomOffset: -1,
        brightness: 1.2,
        maxZoom: 19,
        id: "mapbox/satellite-v9",
        accessToken:
          "pk.eyJ1IjoidG9uZ3p6enoiLCJhIjoiY2s5N3ZuM3hiMGVzYTNncGt6cnVrZHE4eiJ9.jh_uPx9BkdNpdG1LdhenUw",
      }
    );

    var mapbox_streets = L.tileLayer(
      "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
      {
        attribution: "Mapbox",
        tileSize: 512,
        zoomOffset: -1,
        maxZoom: 19,
        brightness: 1.2,
        id: "mapbox/streets-v11",
        accessToken:
          "pk.eyJ1IjoidG9uZ3p6enoiLCJhIjoiY2s5N3ZuM3hiMGVzYTNncGt6cnVrZHE4eiJ9.jh_uPx9BkdNpdG1LdhenUw",
      }
    );

    var baseLayers = {
      Satellite_mapbox: streets_satellite,
      Streets_mapbox: mapbox_streets,
    };

    let layerControl = L.control.layers(baseLayers);

    // Initialize map and add base layers
    this.map = L.map("map", {
      center: [this.lat, this.lon],
      zoom: 13,
      layers: [streets_satellite],
    });

    // Add layer control to map
    layerControl.addTo(this.map);

    this.service.postData({}, "zone/get").then(async (e: any) => {
      const newdata = await e.data.map((feature: any) => {
        return {
          zone_id: feature.zone_id,
          id: feature.id,
          geometry: feature.coordinates,
          properties: feature.properties,
          type: feature.type,
          zone_name: feature.zone_name,
          block_coordinates: feature.block_coordinates,
        };
      });
      const newdata_ = await Promise.all(newdata);
      this.mapbox = newdata_;
      const bule = newdata_.filter((feature: any) => feature.zone_idd == null);

      var css =
        ".text-label { background-color: transparent; color: white; font-size: 13px; border: none; }";
      var style = document.createElement("style");
      style.type = "text/css";
      style.appendChild(document.createTextNode(css));
      document.head.appendChild(style);

      const zone = L.geoJSON(bule, {
        style: { color: "blue", fillOpacity: 0.4 },
        onEachFeature: (feature: any, layer: any) => {
          layer
            .bindTooltip(feature.zone_id, {
              permanent: true,
              direction: "center",
              className: "text-label",
              // opacity: 0.9
            })
            .openTooltip();
          layer.bindPopup(`<p style="font-size: 12px;">
          โซน: ${feature.zone_name}<br>
          </p>`

          );
          layer.on('mouseover', function () {
            this.openPopup();
          });
          layer.on('mouseout', function () {
            this.closePopup();
          });
        },
      });
      zone.addTo(this.map);



      const newGeoJsonLayer = L.geoJSON(bule, {
        style: { color: "blue", fillOpacity: 0.4 },
        onEachFeature: (feature: any, layer: any) => {
          layer
            .bindTooltip(feature.zone_name, {
              permanent: true,
              direction: "center",
              className: "text-label",
              // opacity: 0.9
            })
            .openTooltip();
        },
      });
      zone.addTo(this.map);

      this.map.on("zoomend", () => {
        if (this.map.getZoom() >= 15) {
          newGeoJsonLayer.addTo(this.map);
          layerControl.addOverlay(newGeoJsonLayer, "New GeoJSON");
          this.map.removeLayer(zone);
        } else {
          this.map.removeLayer(newGeoJsonLayer);
          layerControl.removeLayer(newGeoJsonLayer);
          zone.addTo(this.map);
        }
      });
    });
  }

  onClickRow(item) {
    var customIcon = L.icon({
      iconUrl: '../../../assets/img/marker-icon-2x.png',
      iconSize: [30, 45],
      iconAnchor: [23, 35],
      popupAnchor: [-2, -38]
    });

    // Remove the existing marker from the map if there is one
    if (this.marker) {
      this.map.removeLayer(this.marker);
    }

    // Set the latitude and longitude coordinates of the clicked row's item
    this.lat = item.lat;
    this.lon = item.lon;
    this.zone_name = '';

    // Get the zone name from the server
    this.service.postData({ latitude: this.lat, longitude: this.lon }, "zone/get_zone_form_lat_lon")
      .then((result: any) => {
        console.log(result);
        this.zone_name = result.data.zoneName;
        // Create a new marker object
        const marker = L.marker([this.lat, this.lon], { icon: customIcon }).addTo(this.map);

        // Set the popup content on the marker object
        marker.bindPopup(
          `<p style="font-size: 12px;">
            ชื่อ-นามสกุล: ${item.user_name} ${item.user_surname}<br>
            โซนที่อยู่: ${this.zone_name ? this.zone_name : "ไม่พบข้อมูล"}<br>
            สถานะ: ${item.mobile_status}<br>

            </p>`
        );

        // Open the popup on the marker object
        marker.openPopup();
        this.map.setView([this.lat, this.lon], 13);

        // Set the new marker to be the current marker
        this.marker = marker;
      });
  }



}
